import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextAction } from '@calendly/ui/theme';
import { mergeRefs } from '@calendly/ui/utils/merge-refs';
import classNames from 'classnames';
import { useGetUserQuery } from 'common';
import { DateRangePicker } from 'components/core/date_range';
import { Periods } from 'constants/meetings';
import { useFocusPortaledFilterFieldMenuOnOpen, usePortaledFilterFieldMenuFocusRef } from 'hooks/use_focus_portaled_filter_field_menu_on_open';
import { usePortaledMenuAnchor } from 'hooks/use_portaled_menu_anchor';
import { usePortaledMenuPosition } from 'hooks/use_portaled_menu_position';
import { Container } from './dropdown/styles';
import { FilterLayout } from './filter_layout';
import { DateDropdownButton } from './styles';
import { useDateRangeLabel } from './use_date_range_label';
import { getMeetingsFilterMenuPortalRoot } from '../filter_menu_portal_root';
import { DATE_RANGE_DROPDOWN_WIDTH, dateRangeDropdownMenuCss, dateRangeDropdownMenuPhoneCss, dateRangeDropdownScrollShellCss, portaledMenuShellCss } from '../portaled_menu_styles';
const wrapperCss = "w19nwkv";
const dateRangeMenuBodyCss = "d1ffih89";

// This component is reused in SULs, so it's a good candidate for a shared component
export const DateRange = ({
  params,
  onApply,
  isSULFilter = false,
  useColumnLayout = false
}) => {
  const {
    period,
    start_date: startDate,
    end_date: endDate
  } = params;
  const {
    data: {
      timezone
    }
  } = useGetUserQuery();
  const [togglePicker, Dropdown, isPickerOpen, {
    dropdownRef
  }] = useDropdown();
  const isPhone = useDeviceType('isPhone');
  const portalRoot = getMeetingsFilterMenuPortalRoot();
  const {
    anchorRef
  } = usePortaledMenuAnchor();
  usePortaledMenuPosition(isPickerOpen, anchorRef, dropdownRef, {
    placement: 'bottom-start',
    defaultMenuWidth: DATE_RANGE_DROPDOWN_WIDTH,
    useViewportBounds: true
  });
  useFocusPortaledFilterFieldMenuOnOpen(isPickerOpen, dropdownRef);
  const setMenuFocusRef = usePortaledFilterFieldMenuFocusRef(isPickerOpen, dropdownRef);
  const onChange = values => {
    if (values.period === Periods.FIXED) {
      onApply({
        ...params,
        period: values.period,
        start_date: values.startDate,
        end_date: values.endDate
      });
    } else {
      onApply({
        ...params,
        period: values.period === Periods.ALL_TIME ? Periods.UPCOMING : values.period,
        start_date: null,
        end_date: null
      });
    }
  };
  const label = useDateRangeLabel(period, startDate, endDate);
  const labelText = isSULFilter ? I18n.t('publisher.scheduling.shared.filter.labels.date_created') : I18n.t('publisher.meetings.filter_modal.dates.label');
  const menu = isPickerOpen && <Dropdown>
      <FixedContainer ref={mergeRefs(dropdownRef, setMenuFocusRef)} fixedWhen root={portalRoot ?? undefined} className={classNames(portaledMenuShellCss, {
      [dateRangeDropdownScrollShellCss]: isPhone
    })} onClick={event => event.stopPropagation()}>
        <Container data-component="filter-dropdown-menu" className={classNames(dateRangeMenuBodyCss, isPhone ? dateRangeDropdownMenuPhoneCss : dateRangeDropdownMenuCss)}>
          <DateRangePicker period={period} startDate={startDate} endDate={endDate} timezone={timezone} onChange={onChange} isMIPage />
        </Container>
      </FixedContainer>
    </Dropdown>;
  return <FilterLayout label={labelText} useColumnLayout={useColumnLayout}>
      <DateDropdownButton ref={anchorRef} className={wrapperCss} onClick={togglePicker} data-testid="filter-date-range-trigger" aria-expanded={isPickerOpen}>
        {label}
        {isPickerOpen ? <ArrowChevronUpMiniIcon color={colorTextAction} /> : <ArrowChevronDownMiniIcon color={colorTextAction} />}
      </DateDropdownButton>
      {menu}
    </FilterLayout>;
};

require("./date_range.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./date_range.js");